<script setup lang="ts">
  import ProjectNavigationDrawer from './ProjectNavigationDrawer.vue'
  import GIDrawer from '@/components/projectDetail/GIDrawer/GIDrawer.vue'
  import ProfileDrawer from '@/components/projectDetail/ProfileDrawer/ProfileDrawer.vue'
  import RasterDataDrawer from '@/components/projectDetail/RasterDataDrawer/RasterDataDrawer.vue'
  import UserManagementDrawer from '@/components/projectDetail/UserManagementDrawer/UserManagementDrawer.vue'
  import LabResultsDrawer from '@/components/projectDetail/LabResultsDrawer/LabResultsDrawer.vue'
  import ClassificationDrawer from '@/components/projectDetail/ClassificationDrawer/ClassificationDrawer.vue'

  const store = useProjectStore()
</script>

<template>
  <div class="h-100">
    <ProjectNavigationDrawer />
    <ProfileDrawer v-if="store.profileDrawer.shown" />
    <ClassificationDrawer v-if="store.classificationDrawer.shown" />
    <RasterDataDrawer v-if="store.rasterDataDrawer.shown" />
    <GIDrawer v-if="store.groundInvestigationDrawer.shown" />
    <UserManagementDrawer v-if="store.userManagementDrawer.shown" />
    <LabResultsDrawer v-if="store.labResultsDrawer.shown" />
  </div>
</template>

<style scoped></style>
